import React, { Component } from "react";
import "setimmediate";
import MainApp from "../../mobile/src/App";

// FIXME need reanimated update, see https://github.com/software-mansion/react-native-reanimated/issues/3355
if (process.browser) {
  // @ts-ignore
  window._frameTimestamp = null;
}

const App = () => {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <MainApp />
    </div>
  );
};

export default App;
